<section class="rounded-lg border border-slate-200 bg-white p-4 shadow-sm">
  <app-tabs-v2 #tabsRef [tabList]="tabs" (onSelectTab)="onSelectTab($event)" />

  <div class="mt-3">
    @switch ($safeNavigationMigration(selectedTab?.value)) {
      @case (CardGeneralTab.CASE) {
        <app-board-v3-card-case-panel
          [cardId]="cardId"
          [managers]="managers"
          [prefill]="reminderPrefill"
          (reminderAdded)="reminderAdded.emit($event)"
        />
      }
      @case (CardGeneralTab.COMMENTS) {
        <app-board-v3-card-comments-panel [cardId]="cardId" (commentAdded)="commentAdded.emit($event)" />
      }
      @case (CardGeneralTab.CHATS) {
        <app-board-v3-card-chats-panel [cardId]="cardId" [chats]="chats" />
      }
      @case (CardGeneralTab.CALLS) {
        <app-board-v3-card-calls-panel [cardId]="cardId" />
      }
      @case (CardGeneralTab.TASKS) {
        <app-board-v3-card-tasks-panel
          [cardId]="cardId"
          [cardName]="cardName"
          [funnelType]="funnelType"
          (totalChange)="tasksTotal = $event"
        />
      }
    }
  </div>
</section>
